export default __webpack_public_path__ + "static/media/android.56e247e1.png";